module.exports = __webpack_public_path__ + "static/media/marina.d7a6de64.jpeg";